/* Maharaja Product - behaviour for the product page sections (mm-product-*).
   Main: gallery (thumbnails, arrows, swipe, hover zoom), full-screen photos, quantity capped at the
   pieces in stock (minus what is already in the cart), Add to cart through the theme's cart drawer
   (Ella), Buy it now (add, then checkout), options, delivery by PIN, share, sticky bar, and this saree
   remembered for "Recently viewed". Reviews: the buttons open Judge.me's form. Related: Shopify's
   product recommendations. Recently viewed: real cards for the sarees seen in this browser. */
(function () {
  'use strict';
  if (window.__mmPdp) return;
  window.__mmPdp = true;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const store = {
    // a stored value of the wrong shape (e.g. {} where a list is expected) falls back to the default
    get(k, d) { try { const v = localStorage.getItem(k); if (v == null) return d; const p = JSON.parse(v); return Array.isArray(d) && !Array.isArray(p) ? d : p; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }
  };
  const RECENT = 'mm-shop-recent'; // shared with the Shop page (mm-shop.js)

  /* ---------------- toasts ---------------- */
  let toastBox = null;
  const toast = (msg, link) => {
    if (!toastBox) { toastBox = document.createElement('div'); toastBox.className = 'mm-pdp-toasts'; toastBox.setAttribute('aria-live', 'polite'); document.body.appendChild(toastBox); }
    const t = document.createElement('div');
    t.className = 'mm-pdp-toast'; t.textContent = msg;
    if (link) { const a = document.createElement('a'); a.href = link.href; a.textContent = link.label; t.appendChild(a); }
    toastBox.appendChild(t); setTimeout(() => t.remove(), 3300);
  };

  /* ---------------- colour swatches from the colour name ---------------- */
  const SWATCH = [
    [['black', 'charcoal', 'onyx'], '#1f1a19'], [['maroon', 'wine', 'red', 'crimson', 'rust', 'arakku'], '#9b1b24'],
    [['pink', 'magenta', 'rose', 'rani'], '#c2337a'], [['purple', 'violet', 'lavender', 'lilac'], '#5b2a86'],
    [['turquoise', 'teal', 'peacock'], '#1f8a8f'], [['blue', 'navy'], '#1f4e8c'], [['green', 'olive', 'lime', 'parrot'], '#2f6b3a'],
    [['mustard', 'yellow', 'orange', 'peach', 'mango'], '#d99a1e'], [['gold', 'ivory', 'cream', 'beige', 'sand', 'off white'], '#dcc490'],
    [['brown', 'coffee'], '#6b4426'], [['white'], '#f7f3ea'], [['grey', 'gray', 'silver'], '#9a9590']
  ];
  const colourOf = name => { const n = (name || '').toLowerCase(); let best = null, at = 1e9; SWATCH.forEach(([w, c]) => w.forEach(x => { const i = n.indexOf(x); if (i > -1 && i < at) { at = i; best = c; } })); return best; };
  const paintSwatches = scope => $$('.sw[data-cname]', scope).forEach(sw => {
    // up to two colours: "Violet with turquoise border" → violet + turquoise
    const parts = sw.dataset.cname.split(/,|&| and | with /i).map(colourOf).filter(Boolean);
    if (!parts.length) { sw.hidden = true; return; }
    sw.style.setProperty('--c', parts[0]);
    if (parts[1] && parts[1] !== parts[0]) {
      const two = sw.cloneNode(); two.removeAttribute('data-cname'); two.style.setProperty('--c', parts[1]); two.style.marginLeft = '-14px';
      sw.after(two);
    }
  });

  /* ---------------- cart: the theme's drawer (Ella) when it is there ---------------- */
  const drawerEl = () => {
    const d = document.querySelector('cart-drawer');
    return d && typeof d.getSectionsToRender === 'function' && typeof d.renderContents === 'function' ? d : null;
  };
  const openCart = () => {
    const opener = document.querySelector('side-drawer-opener[data-side-drawer="#Cart-Drawer"], [data-side-drawer="#Cart-Drawer"], #cart-icon-bubble');
    if (opener) opener.click(); else location.href = root + 'cart';
  };
  const refreshBubble = () => fetch(root + 'cart.js').then(r => r.json()).then(cart => {
    const n = cart.item_count;
    $$('.cart-bubble').forEach(b => b.classList.toggle('visually-hidden', !n));
    $$('.cart-bubble__text-count').forEach(c => c.classList.toggle('hidden', !n));
    $$('.cart-bubble__text-count span[aria-hidden], .cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(el => { el.textContent = n < 100 ? n : '99+'; });
    return cart;
  }).catch(() => null);
  const postAdd = (body, { drawer = true } = {}) => {
    const d = drawer ? drawerEl() : null;
    if (d) {
      body.append('sections', d.getSectionsToRender().map(s => s.id));
      body.append('sections_url', location.pathname);
      if (typeof d.setActiveElement === 'function') d.setActiveElement(document.activeElement);
    }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok || j.status) throw new Error(j.description || j.message || 'Could not add this saree');
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-product', productVariantId: body.get('id'), cartData: j }); } catch (e) { }
        document.dispatchEvent(new CustomEvent('mm:cart:add', { bubbles: true, detail: j }));
        return { data: j, drawer: d };
      });
  };

  /* =====================================================================
     Main product section
     ===================================================================== */
  function initMain(el) {
    if (el.dataset.mmReady) return;
    el.dataset.mmReady = '1';
    el.classList.add('mm-js');
    const ac = new AbortController(), opt = { signal: ac.signal };
    el._mmDestroy = () => { ac.abort(); document.body.classList.remove('has-pdp-bar'); };
    let data = { variants: [], inCart: 0 };
    try { data = JSON.parse($('[data-pdp-json]', el).textContent); } catch (e) { }
    const form = $('form.pdp-form', el);
    const idIn = $('[data-pdp-id]', el);
    let adding = false;
    const variant = () => data.variants.find(x => String(x.id) === String(idIn && idIn.value)) || data.variants[0] || {};
    paintSwatches(el);

    /* ---------- gallery ---------- */
    const track = $('[data-pdp-track]', el), slides = $$('.pdp-slide', track), N = slides.length;
    const thumbs = $$('.pdp-thumbs button', el), dots = $$('.pdp-dots i', el);
    const prev = $('[data-step="-1"]', el), next = $('[data-step="1"]', el);
    let cur = 0;
    const label = i => (slides[i] && slides[i].dataset.label) || '';
    const paint = i => {
      cur = i;
      const num = $('[data-pdp-num]', el); if (num) num.textContent = `${i + 1} / ${N}`;
      const lab = $('[data-pdp-label]', el); if (lab) lab.textContent = label(i);
      thumbs.forEach((b, k) => b.setAttribute('aria-current', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= N - 1;
    };
    const go = i => { if (!N) return; i = Math.max(0, Math.min(N - 1, i)); track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); paint(i); };
    thumbs.forEach(b => b.addEventListener('click', () => go(+b.dataset.go), opt));
    $$('[data-step]', el).forEach(b => b.addEventListener('click', () => go(cur + +b.dataset.step), opt));
    if (track) {
      track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } }, opt);
      let sT = null;
      track.addEventListener('scroll', () => { clearTimeout(sT); sT = setTimeout(() => paint(Math.round(track.scrollLeft / track.clientWidth)), 60); }, { passive: true, signal: ac.signal });
    }
    // hover zoom (desktop): the photo grows under the pointer; a click opens the full-screen view
    if (fine) slides.forEach(s => {
      const im = $('img', s); if (!im) return;
      s.addEventListener('pointerenter', () => s.classList.add('is-zoom'), opt);
      s.addEventListener('pointerleave', () => { s.classList.remove('is-zoom'); im.style.transformOrigin = ''; }, opt);
      s.addEventListener('pointermove', e => {
        const r = s.getBoundingClientRect();
        im.style.transformOrigin = `${((e.clientX - r.left) / r.width * 100).toFixed(1)}% ${((e.clientY - r.top) / r.height * 100).toFixed(1)}%`;
      }, opt);
    });

    /* ---------- full-screen photos: swipe, tap to zoom, drag to look around ---------- */
    const lb = $('[data-pdp-lb]', el);
    if (lb) {
      const lbTrack = $('[data-lb-track]', lb), lbSlides = $$('.lb-slide', lbTrack), lbThumbs = $$('[data-lb-go]', lb);
      let lbCur = 0, lbLast = null;
      const lbPaint = i => {
        lbCur = i;
        $('[data-lb-num]', lb).textContent = `${i + 1} / ${lbSlides.length}`;
        $('[data-lb-label]', lb).textContent = label(i);
        lbThumbs.forEach((b, k) => b.setAttribute('aria-current', k === i));
      };
      const lbGo = (i, smooth = true) => {
        i = Math.max(0, Math.min(lbSlides.length - 1, i));
        lbSlides.forEach(s => s.classList.remove('is-zoom'));
        lbTrack.style.overflowX = '';
        lbTrack.scrollTo({ left: lbSlides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
        lbPaint(i);
      };
      const lbOpen = i => {
        lbLast = document.activeElement;
        lb.inert = false; lb.classList.add('is-open'); document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => lbGo(i, false));
        setTimeout(() => $('[data-lb-close]', lb).focus(), 60);
      };
      const lbClose = () => {
        lb.classList.remove('is-open'); lb.inert = true; document.body.style.overflow = '';
        lbSlides.forEach(s => s.classList.remove('is-zoom'));
        go(lbCur); if (lbLast && lbLast.focus) lbLast.focus();
      };
      slides.forEach((s, i) => s.addEventListener('click', () => lbOpen(i), opt));
      const openBtn = $('[data-lb-open]', el); if (openBtn) openBtn.addEventListener('click', () => lbOpen(cur), opt);
      $('[data-lb-close]', lb).addEventListener('click', lbClose, opt);
      lbThumbs.forEach(b => b.addEventListener('click', () => lbGo(+b.dataset.lbGo), opt));
      $$('.lb-arrow', lb).forEach(b => b.addEventListener('click', () => lbGo(lbCur + +b.dataset.d), opt));
      let lbT = null;
      lbTrack.addEventListener('scroll', () => { clearTimeout(lbT); lbT = setTimeout(() => lbPaint(Math.round(lbTrack.scrollLeft / lbTrack.clientWidth)), 80); }, { passive: true, signal: ac.signal });
      lbSlides.forEach(s => {
        const im = $('img', s); if (!im) return;
        const aim = e => { const r = s.getBoundingClientRect(); im.style.transformOrigin = `${((e.clientX - r.left) / r.width * 100).toFixed(1)}% ${((e.clientY - r.top) / r.height * 100).toFixed(1)}%`; };
        s.addEventListener('click', e => { const on = !s.classList.contains('is-zoom'); aim(e); s.classList.toggle('is-zoom', on); lbTrack.style.overflowX = on ? 'hidden' : ''; }, opt);
        s.addEventListener('pointermove', e => { if (s.classList.contains('is-zoom')) aim(e); }, opt);
      });
      document.addEventListener('keydown', e => {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Tab') {
          const items = $$('button:not([disabled]), a[href], [tabindex="0"]', lb).filter(item => item.offsetParent !== null);
          const first = items[0], last = items[items.length - 1];
          if (first && e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (last && !e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
        if (e.key === 'Escape') { e.stopPropagation(); lbClose(); }
        if (e.key === 'ArrowRight') lbGo(lbCur + 1);
        if (e.key === 'ArrowLeft') lbGo(lbCur - 1);
      }, opt);
      ac.signal.addEventListener('abort', () => { if (lb.classList.contains('is-open')) lbClose(); });
    }

    /* ---------- quantity, never more than the pieces in stock minus those already in the cart ---------- */
    const qIn = $('[data-qty]', el), qDown = $('[data-qty-step="-1"]', el), qUp = $('[data-qty-step="1"]', el), qNote = $('[data-qty-note]', el);
    const addBtn = $('[data-pdp-add]', el), barAdd = $('[data-pdp-bar-add]', el), nowBtn = $('[data-pdp-now]', el);
    const buyRow = $('[data-pdp-buyrow]', el);
    const T = el.dataset;
    let inCart = +data.inCart || 0;
    const stockOf = () => +variant().stock || 0;          // 0 = not limited
    const left = () => stockOf() ? Math.max(0, stockOf() - inCart) : Infinity;
    const setQty = n => {
      if (!qIn) return 1;
      const max = Math.max(1, Math.min(left(), 999));
      const val = Math.min(max, Math.max(1, Math.round(+n) || 1));
      qIn.value = val; qIn.max = max;
      if (qDown) qDown.disabled = val <= 1;
      if (qUp) qUp.disabled = val >= max;
      return val;
    };
    const setLabel = (b, txt) => { if (b) { const sp = $('span', b); if (sp) sp.textContent = txt; } };
    const paintBuy = () => {
      const v = variant(), st = stockOf(), full = v.available && st > 0 && left() === 0;
      [addBtn, barAdd].forEach(b => {
        if (!b) return;
        b.disabled = adding || !v.available;
        b.classList.toggle('is-added', full);
        setLabel(b, !v.available ? (T.txtSold || 'Sold out') : full ? T.txtInCart : (b.dataset.label || (b.dataset.label = $('span', b).textContent)));
      });
      if (nowBtn) nowBtn.hidden = !v.available || full;
      const stock = $('[data-pdp-stock]', el);
      if (stock) {
        stock.hidden = !!v.available && (!st || st > (+T.few || 5));
        stock.classList.toggle('is-out', !v.available);
        const text = $('span', stock);
        if (text) {
          const label = document.createElement('b');
          label.textContent = !v.available ? (T.txtSold || 'Sold out') : st === 1 ? (T.txtOne || 'Only 1 piece.') : (T.txtFew || 'Only [n] left.').replace('[n]', st);
          const detail = !v.available ? T.txtSoldText : st === 1 ? T.txtOneText : '';
          text.replaceChildren(label, detail ? ' ' + detail : '');
        }
      }
      if (buyRow) buyRow.classList.toggle('is-full', full || !v.available);
      setQty(qIn ? qIn.value : 1);
      if (qNote) qNote.textContent = !v.available || !st ? ''
        : full ? (st === 1 ? '' : `All ${st} pieces are in your cart.`)
          : inCart ? `${inCart} already in your cart · ${left()} more available.`
            : st === 1 ? 'Only 1 piece of this saree is available.' : '';
    };
    if (qIn) {
      if (qDown) qDown.addEventListener('click', () => setQty(+qIn.value - 1), opt);
      if (qUp) qUp.addEventListener('click', () => setQty(+qIn.value + 1), opt);
      qIn.addEventListener('change', () => { const want = +qIn.value; if (setQty(want) < want) toast(`Only ${left()} available`); }, opt);
    }
    // the cart may have changed elsewhere (drawer, other tab): recount this saree
    let recountVersion = 0;
    const recount = () => {
      const version = ++recountVersion, variantId = variant().id;
      return fetch(root + 'cart.js', { signal: ac.signal }).then(r => r.json()).then(c => {
      if (ac.signal.aborted || version !== recountVersion || String(variantId) !== String(variant().id)) return;
      inCart = c.items.filter(i => String(i.variant_id) === String(variant().id)).reduce((a, i) => a + i.quantity, 0);
      paintBuy();
      }).catch(() => { });
    };
    document.addEventListener('mm:cart:add', () => setTimeout(recount, 50), opt);
    addEventListener('pageshow', e => { if (e.persisted) recount(); }, opt);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') recount(); }, opt);
    // Ella's drawer (+ / − / remove) posts to /cart/change: count again afterwards
    document.addEventListener('click', e => { if (e.target.closest('cart-drawer, #Cart-Drawer, .cart-drawer')) setTimeout(recount, 900); }, opt);

    const formData = () => { const fd = new FormData(form); if (qIn) fd.set('quantity', setQty(qIn.value)); return fd; };
    const busy = on => {
      adding = on;
      if (idIn && idIn.tagName === 'SELECT') idIn.disabled = on;
      [addBtn, barAdd, nowBtn].forEach(b => { if (b) { b.classList.toggle('is-loading', on); b.disabled = on || !variant().available; } });
    };
    const add = () => {
      if (adding) return;
      if (!variant().available) return;
      if (stockOf() && !left()) { openCart(); return; }
      const fd = formData(), n = +fd.get('quantity') || 1;
      busy(true); [addBtn, barAdd].forEach(b => b && (b.disabled = true));
      postAdd(fd)
        .then(({ data: j, drawer }) => {
          inCart += n;
          if (qIn) qIn.value = 1;
          if (drawer) drawer.renderContents(j);
          else { toast(T.txtAdded || 'Added to your cart', { href: root + 'cart', label: 'View cart' }); refreshBubble(); }
        })
        .catch(err => toast(err.message))
        .finally(() => { busy(false); paintBuy(); });
    };
    if (form) form.addEventListener('submit', e => { if (!window.fetch) return; e.preventDefault(); add(); }, opt);
    if (barAdd) barAdd.addEventListener('click', add, opt);
    if (nowBtn) nowBtn.addEventListener('click', () => {
      if (adding || !variant().available) return;
      const fd = formData();
      busy(true); nowBtn.disabled = true;
      // already holding every piece? go straight on
      const step = stockOf() && !left() ? Promise.resolve() : postAdd(fd, { drawer: false });
      step.then(() => { location.href = root + 'checkout'; })
        .catch(err => { toast(err.message); busy(false); nowBtn.disabled = false; });
    }, opt);

    /* ---------- options: price, SKU, stock and the URL follow the chosen variant ---------- */
    if (idIn && idIn.tagName === 'SELECT') idIn.addEventListener('change', () => {
      const v = variant();
      const pr = $('[data-pdp-price]', el); if (pr) pr.textContent = v.price;
      const cmp = $('[data-pdp-compare]', el); if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.lastChild.textContent = v.compare; }
      const bp = $('[data-pdp-bar-price]', el); if (bp) bp.textContent = v.price;
      $$('[data-pdp-sku]', el).forEach(x => { x.textContent = v.sku || ''; });
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      inCart = 0;
      paintBuy();
      recount();
    }, opt);

    /* ---------- delivery by PIN code: an estimate from the section's days ---------- */
    const pin = $('[data-pdp-pin]', el);
    if (pin) {
      const input = $('input', pin), out = $('[data-pin-out]', pin);
      const range = t => { const m = String(t || '').match(/(\d+)\D+(\d+)/); return m ? [+m[1], +m[2]] : [3, 7]; };
      const day = n => { const d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      pin.addEventListener('submit', e => {
        e.preventDefault();
        const val = input.value.trim();
        if (!/^[1-9]\d{5}$/.test(val)) { out.classList.add('is-err'); out.textContent = out.dataset.err; return; }
        out.classList.remove('is-err');
        const [a, b] = range(/^6[0-4]/.test(val) ? T.pinTn : T.pinOther);
        const esc = s => s.replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));
        out.innerHTML = esc(out.dataset.ok).replace('[pin]', `<b>${val}</b>`).replace('[from]', day(a)).replace('[to]', day(b))
          + (out.dataset.note ? `<small class="pin-note">${esc(out.dataset.note)}</small>` : '');
        store.set('mm-pin', val);
      }, opt);
      input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, '').slice(0, 6); }, opt);
      const saved = store.get('mm-pin', '');
      if (saved) { input.value = saved; pin.requestSubmit ? pin.requestSubmit() : pin.dispatchEvent(new Event('submit', { cancelable: true })); }
    }

    /* ---------- share: copy the link ---------- */
    const copy = $('[data-pdp-copy]', el);
    if (copy) copy.addEventListener('click', () => {
      const url = copy.dataset.pdpCopy;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(() => toast('Link copied')).catch(() => toast(url));
    }, opt);

    /* ---------- the wishlist heart: Ella's <wish-list> saves it; paint the saved state ---------- */
    const paintWish = () => {
      const list = store.get('wishlistItem', []) || [];
      $$('[data-wishlist-handle]', el).forEach(b => { const on = list.indexOf(b.dataset.wishlistHandle) > -1; b.classList.toggle('wishlist-added', on); b.setAttribute('aria-pressed', on); });
    };
    paintWish();
    document.addEventListener('add:wishlist-item', paintWish, opt);
    document.addEventListener('remove:wishlist-item', paintWish, opt);

    /* ---------- sticky bar once the main button scrolls away ---------- */
    const bar = $('[data-pdp-bar]', el);
    if (bar && buyRow && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on);
        if (barAdd) barAdd.tabIndex = on ? 0 : -1;
        // the page gets the bar's height as bottom room, so the footer links are never left under it
        if (on) document.documentElement.style.setProperty('--mm-pdp-bar-h', bar.offsetHeight + 'px');
        document.body.classList.toggle('has-pdp-bar', on);
      });
      io.observe(buyRow);
      ac.signal.addEventListener('abort', () => io.disconnect());
    }

    /* ---------- remember this saree for "Recently viewed" (same list as the Shop page) ---------- */
    if (T.handle && !window.Shopify?.designMode) {
      const item = { h: T.handle, t: T.title, u: T.url, i: T.image, p: T.price, f: T.fab };
      store.set(RECENT, [item, ...store.get(RECENT, []).filter(x => x && x.h !== item.h)].slice(0, 12));
      // also the theme's own list (product ids, newest first), read by the floating "Recently viewed"
      // drawer (multitasking bar); the theme's product-info.js writes it on its own product pages
      const pid = parseInt(T.productId, 10);
      if (pid) store.set('_halo_recently_viewed', [pid, ...(store.get('_halo_recently_viewed', []) || []).filter(x => x !== pid)].slice(0, 25));
    }

    paint(0);
    paintBuy();
  }

  /* =====================================================================
     Reviews: our buttons open Judge.me's form
     ===================================================================== */
  function initReviews(el) {
    if (el.dataset.mmReady) return;
    el.dataset.mmReady = '1';
    el.classList.add('mm-js');
    // the saree has reviews: a quiet placeholder card until Judge.me has drawn them (mm-popups.css).
    // A class, not a :has() rule - :not(:has()) made Chrome restyle every page on each scroll step.
    const jdgm = $('.pdp-jdgm', el);
    if (jdgm && $('.pdp-reviews--has', el) && !$('.jm-review-item', jdgm)) {
      jdgm.classList.add('pdp-jdgm--wait');
      const mo = new MutationObserver(() => {
        if (!$('.jm-review-item', jdgm)) return;
        jdgm.classList.remove('pdp-jdgm--wait'); mo.disconnect();
      });
      mo.observe(jdgm, { childList: true, subtree: true });
    }
    el.addEventListener('click', e => {
      const b = e.target.closest('[data-pdp-write]'); if (!b) return;
      e.preventDefault();
      // Judge.me's own "Write a review": the current widget (app block) has a button, the older
      // metafield widget a link
      const WRITE = '[data-testid="write-review-button"], .jm-action-buttons__button, .jdgm-write-rev-link';
      const link = $(WRITE, el) || document.querySelector(WRITE);
      const widget = $('.pdp-jdgm', el);
      if (link) {
        link.click();
        setTimeout(() => {
          const form = $('.jdgm-form-wrapper, [class*="jm-review-form"], form[class*="jm-"]', el) || widget || link;
          form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }, 300);
      }
      else if (b.dataset.fallback) location.href = b.dataset.fallback;
      else toast('Reviews open once the Judge.me app is switched on');
    });
  }

  /* =====================================================================
     Related: Shopify's recommendations replace the collection fallback when there are any
     ===================================================================== */
  function initRelated(el) {
    if (el.dataset.mmReady) return;
    el.dataset.mmReady = '1';
    el.classList.add('mm-js');
    const url = el.dataset.recsUrl;
    if (!url) return;
    fetch(url).then(r => r.text()).then(text => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const grid = $('[data-pdp-grid]', doc), cards = grid ? $$('.pc', grid) : [];
      if (cards.length) {
        const mine = $('[data-pdp-grid]', el);
        mine.replaceChildren(...cards.map(c => document.importNode(c, true)));
        el.dataset.pdpLoaded = '1';
        el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = false);
        el.hidden = false;
        paintWishCards(el);
      }
    }).catch(() => { });
  }

  /* =====================================================================
     Recently viewed: each saree's real card (live price and stock) from this section rendered at its URL
     ===================================================================== */
  function initRecent(el) {
    if (el.dataset.mmReady) return;
    el.dataset.mmReady = '1';
    el.classList.add('mm-js');
    const me = el.dataset.handle, limit = +el.dataset.limit || 4, sid = el.dataset.sectionId;
    const list = (store.get(RECENT, []) || []).filter(x => x && x.h && x.h !== me).slice(0, limit);
    if (!list.length) return;
    const grid = $('[data-pdp-grid]', el);
    // the section file name renders for any product, whichever template it uses; this instance's id
    // is only on products that share this template, so it is the fallback
    const card = (h, id) => fetch(`${root}products/${encodeURIComponent(h)}?section_id=${encodeURIComponent(id)}`).then(r => r.ok ? r.text() : null);
    Promise.all(list.map(x => card(x.h, 'mm-product-recent')
      .then(t => t || (sid ? card(x.h, sid) : null))
      .then(t => { if (!t) return null; const tpl = new DOMParser().parseFromString(t, 'text/html').querySelector('template[data-pdp-card]'); return tpl ? tpl.content.firstElementChild : null; })
      .catch(() => null)))
      .then(cards => {
        cards = cards.filter(Boolean);
        if (!cards.length) return;
        grid.replaceChildren(...cards.map(c => document.importNode(c, true)));
        el.hidden = false;
        paintWishCards(el);
      });
  }

  const paintWishCards = scope => {
    const list = store.get('wishlistItem', []) || [];
    $$('[data-wishlist-handle]', scope).forEach(b => { const on = list.indexOf(b.dataset.wishlistHandle) > -1; b.classList.toggle('wishlist-added', on); b.setAttribute('aria-pressed', on); });
  };

  /* =====================================================================
     Start + theme editor hooks
     ===================================================================== */
  // one part failing (e.g. odd saved data) must not stop the others from starting
  const safe = fn => el => { try { fn(el); } catch (e) { console.error('[mm-product]', e); } };
  const initAll = scope => {
    $$('[data-mm-pdp]', scope).forEach(safe(initMain));
    $$('[data-pdp-reviews]', scope).forEach(safe(initReviews));
    $$('[data-pdp-related]', scope).forEach(safe(initRelated));
    $$('[data-pdp-recent]', scope).forEach(safe(initRecent));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:unload', e => { $$('[data-mm-pdp]', e.target).forEach(r => { if (r._mmDestroy) r._mmDestroy(); }); });
})();
